<template>
  <div v-loading.absolute="isLoading" class="mod-holdings-detail">
    <header class="panel-header">
      <h2 class="title">
        {{ title || $t('trade.holdingsDetail') }}
      </h2>
      <icon name="cross" @click.native="close" />
    </header>
    <div class="symbol-name" :title="symbolName">
      <span> {{ symbolName }} </span>
    </div>
    <PnlAttributes :detail="detail" />
    <!-- 盈亏曲线 -->
    <ProfitLoss
      v-if="showProfitLoss"
      :stock="stock"
      :order="detail"
      :position="detail.position"
      context="detail"
      :is-detail="true"
    />
    <Tabs class="trades-dividends-info">
      <Tab :title="$t('trade.holdings-detail-page.trade-details')">
        <TradeTable :trades="trades" :loading="isLoading" :stock="stock" />
      </Tab>
      <Tab :title="$t('trade.holdings-detail-page.dividend-record')">
        <DividendTable
          :market="stock.market"
          :loading="isLoading"
          :dividends="detail.dividends"
        />
      </Tab>
    </Tabs>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import TradeTable from './TradeTable'
import DividendTable from './DividendTable'
import PnlAttributes from './PnlAttributes'
import ProfitLoss from 'mod/ProfitLoss'
import { SEC_TYPE } from 'const/stock'
import Tabs from 'com/Tab'
import Icon from 'com/Icon'
import Modal from 'com/Modal'
import { mapGetters } from 'vuex'
import getLocalFixedQuoteDetail from 'utils/getLocalFixedQuoteDetail'

export default {
  name: 'HoldingsDetail',
  components: {
    ...Tabs,
    TradeTable,
    PnlAttributes,
    DividendTable,
    Icon,
    Modal,
    ProfitLoss
  },
  props: ['stock', 'title', 'showProfitLossCurve'],
  data() {
    return {
      isLoading: false,
      pnl: null,
      dividends: []
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    ...mapGetters(['language', 'isIb', 'curAccountId']),
    symbol() {
      return this.detail.webLocal.symbol
    },
    detail() {
      return getLocalFixedQuoteDetail({
        ...this.pnl,
        ...this.stock,
        dividends: this.dividends
      })
    },
    symbolName() {
      if (this.isOPT) {
        return this.$options.filters.formatOptionName(this.detail, 0)
      } else {
        return this.detail.symbol + ' ' + (this.detail.nameCN || '')
      }
    },
    trades() {
      return (
        (this.isIb ? this.detail.trades : this.detail.tradeDetailList) || []
      )
    },
    isOPT() {
      return this.detail.secType === SEC_TYPE.OPT
    },
    showProfitLoss() {
      return this.trades.length && this.showProfitLossCurve && this.isOPT
    }
  },
  watch: {
    symbol() {
      this.loadData()
    },
    curAccountId() {
      this.close()
    },
    language() {
      this.loadData()
    }
  },
  methods: {
    close() {
      this.$emit('closeDetail')
    },
    loadData() {
      this.isLoading = true
      Promise.all([this.getStockPnL(), this.getStockDividend()])
        .then(([pnl, dividends]) => {
          this.pnl = pnl
          this.dividends = dividends.map((d, idx) => ({
            id: this.isIb ? d.timestamp + '_' + idx : d.id,
            date: this.isIb ? d.timestamp : d.createdAt,
            currency: d.currency,
            amount: d.amount
          }))
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getStartDate() {
      return moment()
        .subtract(10, 'y')
        .format('YYYYMMDD')
    },
    getStockPnL() {
      return this.$store.dispatch('getStockPnl', {
        startDate: this.getStartDate(),
        symbol: this.detail.symbol,
        market: this.detail.market,
        secType: this.detail.secType,
        expiry: this.detail.expiry,
        strike: this.detail.strike,
        right: this.detail.right
      })
    },
    getStockDividend() {
      if (this.isOPT) {
        return Promise.resolve([])
      }
      return this.$store.dispatch('getStockDividends', {
        symbol: this.detail.symbol,
        startDate: this.getStartDate()
      })
    }
  }
}
</script>
<style lang="less" scoped src="./styles.less"></style>
